<div class="">
  <div class="">
    <div class="">
      <div class="d-flex flex-column w-100 align-items-center mt-4">
        <b style="font-size: 18px"> Add New Customer to</b>
        <span style="font-size: 18px">{{
          companyName || companySelected
        }}</span>
      </div>
      <div class="card-body">
        <div mat-dialog-content>
          <form name="userNewForm" #userNewForm="ngForm">
            <!-- <div *ngIf="data.company" class="row">
              <div class="">
                <div class="form-group">
                  <label class="bmd-label-floating">Company Name</label>
                  <input
                    type="text"
                    class="form-control"
                    name="companyname"
                    #companyname="ngModel"
                    [(ngModel)]="companyName"
                    disabled
                  />
                </div>
              </div>
            </div> -->
            <mat-stepper>
              <mat-step label="User Information">
                <div *ngIf="!data.company">
                  <app-filter-object
                    *ngIf="!buscandoCompanies"
                    [options]="companies"
                    [value]="companySelected"
                    (selectChange)="changeCompany($event)"
                    placeholder="Company Name"
                  >
                  </app-filter-object>
                  <button (click)="openNuevoCompany()" class="gts-btn-primary">
                    <span class="gts-btn-icon-left"> note_add </span>
                    <span class="gts-btn-text"> New Company </span>
                  </button>
                </div>
                <mat-form-field>
                  <mat-label>Title</mat-label>
                  <input
                    type="text"
                    matInput
                    name="ocupation"
                    [(ngModel)]="data.user.ocupation"
                  />
                </mat-form-field>

                <div class="grid-container">
                  <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input
                      type="text"
                      matInput
                      name="name "
                      [(ngModel)]="data.user.name"
                      required
                    />
                  </mat-form-field>

                  <!-- <div class="form-group">
                    <label class="bmd-label-floating">First Name</label>
                    <input
                      type="text"
                      class="form-control"
                      name="name"
                      #name="ngModel"
                      [(ngModel)]="data.user.name"
                      required
                    />
                    <span *ngIf="!name.valid && name.touched"> ¡Name not valid! </span>
                  </div> -->

                  <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input
                      type="text"
                      matInput
                      name="surname"
                      [(ngModel)]="data.user.surname"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>email</mat-label>
                    <input
                      matInput
                      type="email"
                      name="correo"
                      [(ngModel)]="data.user.email"
                      required
                    />
                  </mat-form-field>
                  <!-- <label
                    class="font-italic"
                    *ngIf="correo.touched && !mtds.emailValid(data.user.email)"
                  >
                    Invalid Mail
                  </label> -->
                  <mat-form-field>
                    <mat-label class="bmd-label-floating">Gender</mat-label>

                    <mat-select
                      name="gender"
                      [(ngModel)]="data.user.gender"
                      placeholder="Gender"
                    >
                      <mat-option
                        *ngFor="let sexo of sexos"
                        [value]="sexo.value"
                      >
                        {{ sexo.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <button
                  class="gts-btn-primary-outline"
                  matRipple
                  matStepperNext
                  [disabled]="isDisabledFirstStep"
                >
                  <span class="gts-btn-icon-left">east</span
                  ><span class="gts-btn-text">Next</span>
                </button>
              </mat-step>
              <mat-step label="Address Information">
                <div class="grid-container grid-container-3">
                  <!-- <div class="form-group">
                    <label class="bmd-label-floating">Addresss </label>
                    <select
                      name="userlocation"
                      #userlocation="ngModel"
                      [(ngModel)]="data.user.locationId"
                      (change)="changeLocation()"
                      class="form-control fctrl"
                    >
                      <option [value]="null">Headquarter's Address</option>
                      <option
                        *ngFor="let loc of companyLocations"
                        [value]="loc.id"
                      >
                        {{ loc.name }}
                      </option>
                    </select>
                  </div> -->

                  <mat-form-field>
                    <mat-label>Saved Addresses </mat-label>
                    <select
                      matNativeControl
                      name="userlocation"
                      [(ngModel)]="data.user.locationId"
                      (change)="changeLocation()"
                    >
                      <option [value]="null">Headquarter's Address</option>
                      <!-- <option [value]="0">Blank - Client Address</option> -->
                      <option
                        *ngFor="let loc of companyLocations"
                        [value]="loc.id"
                      >
                        {{ loc.name }}
                      </option>
                    </select>
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Address Line #</mat-label>
                    <input
                      type="text"
                      name="address"
                      [(ngModel)]="data.user.address"
                      [disabled]="data.user.locationId != 0"
                      matInput
                    />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Address Line 2 #</mat-label>
                    <input
                      matInput
                      type="text"
                      name="address2"
                      [(ngModel)]="data.user.address2"
                      [disabled]="data.user.locationId != 0"
                    />
                  </mat-form-field>
                  <mat-form-field
                    class="w-100"
                    *ngIf="!loadingCountries && countries"
                  >
                    <mat-label>Country</mat-label>
                    <input
                      type="text"
                      matInput
                      [matAutocomplete]="autoCountries"
                      [formControl]="myControlCountries"
                    />
                    <mat-autocomplete
                      #autoCountries="matAutocomplete"
                      [displayWith]="displayCountry"
                      (optionSelected)="onCountrySelected($event.option.value)"
                    >
                      <mat-option
                        *ngFor="let country of filteredCountries | async"
                        [value]="country"
                      >
                        {{ country.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <!-- <mat-form-field>
                  <mat-label>Country</mat-label>
                  <input
                    matInput
                    type="text"
                    name="country"
                    #country="ngModel"
                    [(ngModel)]="data.user.country"
                    [disabled]="data.user.locationId != 0"
                    required
                  />
                </mat-form-field> -->

                  <!-- <mat-form-field>
                  <mat-label>State</mat-label>
                  <input
                    required
                    matInput
                    type="text"
                    name="colonia"
                    #colonia="ngModel"
                    [(ngModel)]="data.user.colonia"
                    [disabled]="data.user.locationId != 0"
                  />
                </mat-form-field> -->
                  <mat-form-field *ngIf="states.length === 0">
                    <mat-label class="bmd-label-floating"
                      >State
                      <i
                        *ngIf="loadingStates"
                        class="fa fa-circle-o-notch fa-spin fa-fw"
                      ></i
                    ></mat-label>
                    <input
                      [disabled]="data.user.locationId != 0"
                      matInput
                      type="text"
                      name="colonia"
                      [(ngModel)]="data.user.colonia"
                      required
                    />
                  </mat-form-field>
                  <mat-form-field class="mr-3" *ngIf="states.length !== 0">
                    <mat-label>
                      State
                      <i
                        *ngIf="loadingStates"
                        class="fa fa-circle-o-notch fa-spin fa-fw"
                      ></i>
                    </mat-label>

                    <input
                      type="text"
                      matInput
                      [formControl]="myControlStates"
                      [matAutocomplete]="auto"
                      required
                    />

                    <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="onStateSelected($event.option.value)"
                      [displayWith]="displayState"
                    >
                      <mat-option
                        *ngFor="let state of filteredStates | async"
                        [value]="state"
                      >
                        {{ state.abbr }} - {{ state.name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>City</mat-label>
                    <input
                      matInput
                      type="text"
                      name="city"
                      [(ngModel)]="data.user.city"
                      [disabled]="data.user.locationId != 0"
                    />
                  </mat-form-field>
                  <mat-form-field class="form-group">
                    <mat-label>Zip Code</mat-label>
                    <input
                      matInput
                      type="text"
                      name="zipCode"
                      [(ngModel)]="data.user.zipCode"
                      [disabled]="data.user.locationId != 0"
                    />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Work Phone</mat-label>
                    <input
                      matInput
                      type="text"
                      class="form-control"
                      name="phone"
                      [(ngModel)]="data.user.phone"
                    />
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Mobile Phone</mat-label>
                    <input
                      matInput
                      type="text"
                      name="mobilePhone"
                      [(ngModel)]="data.user.mobilePhone"
                    />
                  </mat-form-field>
                </div>
                <div class="d-flex">
                  <button
                    class="gts-btn-primary-outline mr-2"
                    matRipple
                    matStepperPrevious
                  >
                    <span class="gts-btn-icon-left">west</span
                    ><span class="gts-btn-text">Previous</span>
                  </button>
                  <button
                    [disabled]="isDisabledSecondStep"
                    class="gts-btn-primary-outline"
                    matRipple
                    matStepperNext
                  >
                    <span class="gts-btn-icon-left">east</span
                    ><span class="gts-btn-text">Next</span>
                  </button>
                </div>
              </mat-step>
              <mat-step label="Settings">
                <mat-form-field>
                  <mat-label>Customer Type</mat-label>
                  <mat-select
                    id="customerType"
                    name="customerType"
                    [(ngModel)]="data.user.customerType"
                    placeholder="Customer Type"
                    required
                  >
                    <mat-option value="End User">End User</mat-option>
                    <mat-option value="Wholesaler">Wholesaler</mat-option>
                    <mat-option value="Broker">Broker</mat-option>
                    <mat-option value="Reseller">Reseller</mat-option>
                  </mat-select>
                </mat-form-field>
                <label *ngIf="loadingReps"
                  >Loading Rep List
                  <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
                ></label>

                <app-filter-object
                  *ngIf="!loadingReps"
                  [options]="repsList"
                  placeholder="Choose Rep"
                  [value]="data.user.user_id"
                  (selectChange)="data.user.user_id = $event.id"
                >
                </app-filter-object>
                <div class="d-flex">
                  <button
                    class="gts-btn-primary-outline mr-2"
                    matRipple
                    matStepperPrevious
                  >
                    <span class="gts-btn-icon-left">west</span
                    ><span class="gts-btn-text">Previous</span>
                  </button>
                  <button
                    class="gts-btn-primary-outline"
                    matRipple
                    matStepperNext
                    [disabled]="isDisabledThirdStep"
                  >
                    <span class="gts-btn-icon-left">east</span
                    ><span class="gts-btn-text">Next</span>
                  </button>
                </div>
              </mat-step>
              <mat-step label="Categories">
                <div class="row">
                  <div class="col-3" *ngFor="let item of categories">
                    <div class="row">
                      <mat-checkbox
                        [name]="item.name"
                        (change)="addCategoire(item, $event)"
                        [checked]="isCheked(item)"
                        >{{ item.name }}</mat-checkbox
                      >
                    </div>
                    <div *ngIf="isAdded(item.id)">
                      <div class="row" *ngIf="item.sub.length > 1">
                        &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                        <mat-checkbox
                          [name]="item.id"
                          (change)="
                            addCategoire(
                              { id: item.id, father: item.id, name: 'All' },
                              $event
                            )
                          "
                          [checked]="checkedAll(item.id)"
                          >All</mat-checkbox
                        >
                      </div>
                      <div class="row" *ngFor="let i of item.sub">
                        &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                        <mat-checkbox
                          [name]="i.name"
                          (change)="addCategoire(i, $event)"
                          [checked]="isCheked(i)"
                          >{{ i.name }}</mat-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex">
                  <button
                    class="gts-btn-primary-outline mr-2"
                    matRipple
                    matStepperPrevious
                  >
                    <span class="gts-btn-icon-left">west</span
                    ><span class="gts-btn-text">Previous</span>
                  </button>
                  <button
                    class="gts-btn-primary-outline"
                    matRipple
                    matStepperNext
                  >
                    <span class="gts-btn-icon-left">east</span
                    ><span class="gts-btn-text">Next</span>
                  </button>
                </div>
              </mat-step>
              <mat-step label="Ranking">
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center flex-column">
                    <label>Pricing: </label>
                    <div class="d-flex">
                      <a
                        class="rank btn-just-icon"
                        *ngFor="let star of [1, 2, 3, 4, 5]"
                        (click)="data.user.customerPricing = star"
                      >
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-star': data.user.customerPricing >= star,
                            'fa-star-o': data.user.customerPricing < star
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-column">
                    <label>Response Time: </label>
                    <div class="d-flex">
                      <a
                        class="rank btn-just-icon"
                        *ngFor="let star of [1, 2, 3, 4, 5]"
                        (click)="data.user.customerResponseTime = star"
                      >
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-star': data.user.customerResponseTime >= star,
                            'fa-star-o': data.user.customerResponseTime < star
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-column">
                    <label>Payment on Time: </label>
                    <div class="d-flex">
                      <a
                        class="rank btn-just-icon"
                        *ngFor="let star of [1, 2, 3, 4, 5]"
                        (click)="data.user.customerPaymentOnTime = star"
                      >
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-star': data.user.customerPaymentOnTime >= star,
                            'fa-star-o': data.user.customerPaymentOnTime < star
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-column">
                    <label>Easy to work with: </label>
                    <div class="d-flex">
                      <a
                        class="rank btn-just-icon"
                        *ngFor="let star of [1, 2, 3, 4, 5]"
                        (click)="data.user.customerEasyToWorkWith = star"
                      >
                        <i
                          class="fa"
                          [ngClass]="{
                            'fa-star': data.user.customerEasyToWorkWith >= star,
                            'fa-star-o': data.user.customerEasyToWorkWith < star
                          }"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="d-flex mt-4">
                  <button
                    class="gts-btn-primary-outline mr-2"
                    matRipple
                    matStepperPrevious
                  >
                    <span class="gts-btn-icon-left">west</span
                    ><span class="gts-btn-text">Previous</span>
                  </button>
                  <button class="gts-btn-primary" (click)="closeModal()">
                    <span class="gts-btn-text"> Save </span>
                  </button>
                </div>
              </mat-step>
            </mat-stepper>
            <!-- 
            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Address Info -
                <small class="category">Address information</small>
              </h4>
            </div> -->

            <div>
              <!-- <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Addresss </label>
                  <select
                    name="userlocation"
                    #userlocation="ngModel"
                    [(ngModel)]="data.user.locationId"
                    (change)="changeLocation()"
                    class="form-control fctrl"
                  >
                    <option [value]="null">Headquarter's Address</option>
                    <option
                      *ngFor="let loc of companyLocations"
                      [value]="loc.id"
                    >
                      {{ loc.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Address Line #</label>
                  <input
                    type="text"
                    class="form-control"
                    name="address"
                    #address="ngModel"
                    [(ngModel)]="data.user.address"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label class="bmd-label-floating">Address Line 2 #</label>
                  <input
                    type="text"
                    class="form-control"
                    name="address2"
                    #address2="ngModel"
                    [(ngModel)]="data.user.address2"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">City</label>
                  <input
                    type="text"
                    class="form-control"
                    name="city"
                    #city="ngModel"
                    [(ngModel)]="data.user.city"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">State</label>
                  <input
                    type="text"
                    class="form-control"
                    name="colonia"
                    #colonia="ngModel"
                    [(ngModel)]="data.user.colonia"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="bmd-label-floating">Country</label>
                  <input
                    type="text"
                    class="form-control"
                    name="country"
                    #country="ngModel"
                    [(ngModel)]="data.user.country"
                    readonly
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label class="bmd-label-floating">Zip Code</label>
                  <input
                    type="text"
                    class="form-control"
                    name="zipCode"
                    #zipCode="ngModel"
                    [(ngModel)]="data.user.zipCode"
                    readonly
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label class="bmd-label-floating">Work Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    name="phone"
                    #phone="ngModel"
                    [(ngModel)]="data.user.phone"
                  />
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label class="bmd-label-floating">Mobile Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    name="mobilePhone"
                    #mobilePhone="ngModel"
                    [(ngModel)]="data.user.mobilePhone"
                  />
                </div>
              </div> -->
            </div>

            <!-- <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Settings
              </h4>
            </div> -->
            <div class="row">
              <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating">Email Frequenc</label>
                    <select (change)="changeCompany()" id="companyform" name="frequency" #frequency="ngModel" [(ngModel)]="data.user.emailFrequency" placeholder="Email Frequenc" class="form-control"required>
                      <option value="" disabled>* Please select a company</option>
                      <option *ngFor="let frequency of frequencies" [value]="frequency.value">  {{ frequency.viewValue }}</option>
                    </select>
                  </div>
                </div> -->
            </div>

            <!-- <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Categories
              </h4>
              <br />
            </div> -->

            <!-- <hr />

            <div class="row">
              <h4
                class="card-title"
                style="margin-left: 20px; margin-top: 40px"
              >
                Ranking
              </h4>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="col-md-4">
    <div class="card">
      <div class="card-header card-header-icon card-header-rose">
        <div class="card-icon">
          <i class="material-icons"></i>
        </div>
        <h4 class="card-title">Password</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating">Password</label>
              <input type="text" name="password" #password="ngModel" [(ngModel)]="data.user.password" required  class="form-control">
            </div>
          </div>
        </div>
      </div>
     </div>
    </div> -->
</div>
